import { render, staticRenderFns } from "./BasicEditForm.vue?vue&type=template&id=3f63b78c&"
import script from "./BasicEditForm.vue?vue&type=script&lang=js&"
export * from "./BasicEditForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports